import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { InvoiceData } from '../models/invoice-data.interface';
import { BasePdfTemplate } from './base-template';
import { getItemUnitName, getSelectedMappingLines } from './helpers/item-display.helper';

/**
 * Default Thermal Template - POS Thermal Printer Size
 * Current ElixirPOS implementation (80mm thermal paper)
 */
export class DefaultThermalTemplate extends BasePdfTemplate {
  override templateName = 'default';
  override templateVersion = '1.0.0';
  override description = 'Default thermal printer template (80mm POS paper)';
  override pageSize: 'THERMAL' = 'THERMAL';

  override generatePdfDefinition(data: InvoiceData): TDocumentDefinitions {
    console.log('default template changesssssssssssssssssss----------->')
    // Free items summary (is_free === 1): total free qty and free value (MRP/original price x qty)
    let totalFreeQty = 0;
    let totalFreeAmount = 0;
    (data.items || []).forEach((item: any) => {
      if (Number(item.is_free) === 1) {
        totalFreeQty += Number(item.quantity || 0);
        totalFreeAmount += Number(item.originalprice || item.mrp || 0) * Number(item.quantity || 0);
      }
    });

    // Subtotal excluding free items (backend subtotal includes free item amount)
    const freeItemsAmount = (data.items || []).reduce((sum: number, item: any) =>
      Number(item.is_free) === 1
        ? sum + Number(item.amount || (item.price || 0) * (item.quantity || 0))
        : sum, 0);
    const subtotalExclFree = Math.max(0, Number(data.subtotal || 0) - freeItemsAmount);
    return {
      pageSize: this.getPageSize(),
      pageMargins: this.getPageMargins(),

      content: [
        // Business Name
        {
          text: data.businessName || 'ElixirPOS',
          style: 'header',
          alignment: 'center',
          fontSize: 14,
          bold: true,
        },

        // Business Info
        {
          text: [
            data.businessAddress || '',
            data.businessPhone ? `\nPhone: ${data.businessPhone}` : '',
            data.businessGSTIN ? `\nGSTIN: ${data.businessGSTIN}` : '',
          ],
          style: 'businessInfo',
          alignment: 'center',
          fontSize: 8,
          margin: [0, 5, 0, 10],
        },

        // Separator
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 206.77,
              y2: 0,
              lineWidth: 1,
              dash: { length: 2 },
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // Invoice Type
        {
          text: data.invoiceType === 'quotation' ? 'QUOTATION' : 'INVOICE',
          alignment: 'center',
          fontSize: 12,
          bold: true,
          margin: [0, 5, 0, 5],
        },

        // Invoice Details
        {
          columns: [
            {
              text: `Invoice: ${data.invoiceNumber}`,
              fontSize: 9,
              bold: true,
              width: '*',
            },
            {
              text: this.formatDate(
                (data.invoiceDate || data.invoicedate) as Date,
              ),
              fontSize: 9,
              alignment: 'right',
              width: '*',
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // Customer Info
        {
          text: [
            `Customer: ${data.customerName || 'Walk in Customer'}\n`,
            `Mobile: ${data.customerMobile || 'N/A'}`,
          ],
          fontSize: 9,
          margin: [0, 0, 0, 10],
        },

        // Separator
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 206.77,
              y2: 0,
              lineWidth: 1,
              dash: { length: 2 },
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // Items Table
        {
          table: {
            headerRows: 1,
            widths: ['*', 30, 35, 45],
            body: [
              // Header
              [
                { text: 'Item', style: 'tableHeader', fontSize: 9 },
                {
                  text: 'Qty',
                  style: 'tableHeader',
                  alignment: 'center',
                  fontSize: 9,
                },
                {
                  text: 'Rate',
                  style: 'tableHeader',
                  alignment: 'right',
                  fontSize: 9,
                },
                {
                  text: 'Total',
                  style: 'tableHeader',
                  alignment: 'right',
                  fontSize: 9,
                },
              ],
              // Items
              // ...data.items.map((item) => [
              //   {
              //     stack: [
              //       { text: item.name, fontSize: 8, bold: true },
              //       item.hsn
              //         ? {
              //             text: `HSN: ${item.hsn}`,
              //             fontSize: 7,
              //             color: '#666666',
              //           }
              //         : {},
              //     ],
              //   },
              //   {
              //     text: item.quantity.toString(),
              //     fontSize: 8,
              //     alignment: 'center',
              //   },
              //   {
              //     text: this.formatCurrencyWhole(item.price),
              //     fontSize: 8,
              //     alignment: 'right',
              //   },
              //   {
              //     text: this.formatCurrencyWhole(item.total),
              //     fontSize: 8,
              //     alignment: 'right',
              //     bold: true,
              //   },
              // ]),
              ...data.items.map((item) => {
                const qty = item.quantity || 1;
                const taxPerUnit = (item.taxamount || item.taxAmount || 0) / qty;
                const inclusivePrice = item.price + taxPerUnit;
                const showInclusive = !!data.discaftertax;

                return [
                  {
                    stack: [
                      { text: `${item.name || ''}${Number(item.is_free) === 1 ? ' [FREE]' : ''}`, fontSize: 8, bold: true },
                      // Selected variants / parameters below the item name — "label : value", one per line
                      ...getSelectedMappingLines(item).map((line: string) => ({ text: line, fontSize: 7 })),
                      // item.hsn
                      //   ? { text: `HSN: ${item.hsn}`, fontSize: 7, color: '#666666' }
                      //   : {},
                      // Unit appended to the HSN sub-line (qty column is too narrow for it);
                      // without HSN, unit gets its own small line
                      item.hsn
                        ? { text: `HSN: ${item.hsn}${getItemUnitName(item) ? `   Unit : ${getItemUnitName(item)}` : ''}`, fontSize: 7, color: '#666666' }
                        : getItemUnitName(item)
                          ? { text: `Unit : ${getItemUnitName(item)}`, fontSize: 7, color: '#666666' }
                          : {},
                    ],
                  },
                  {
                    text: item.quantity.toString(),
                    fontSize: 8,
                    alignment: 'center',
                  },
                  {
                    text: this.formatCurrencyWhole(showInclusive ? inclusivePrice : item.price),
                    fontSize: 8,
                    alignment: 'right',
                  },
                  {
                    text: this.formatCurrencyWhole(Number(item.is_free) === 1 ? 0 : (showInclusive ? inclusivePrice * qty : item.total)),
                    fontSize: 8,
                    alignment: 'right',
                    bold: true,
                  },
                ];
              }),
            ],
          },
          layout: {
            hLineWidth: function (i: number, node: any) {
              return i === 0 || i === 1 || i === node.table.body.length ? 1 : 0;
            },
            vLineWidth: function () {
              return 0;
            },
            paddingLeft: function () {
              return 2;
            },
            paddingRight: function () {
              return 2;
            },
            paddingTop: function () {
              return 2;
            },
            paddingBottom: function () {
              return 2;
            },
          },
          margin: [0, 0, 0, 10],
        },

        // Free Items summary (only when free items exist)
        totalFreeQty > 0
          ? {
            columns: [
              { text: `Free Items : ${totalFreeQty}`, fontSize: 9, bold: true, width: '*' },
              {
                text: totalFreeAmount.toFixed(2),
                fontSize: 9,
                bold: true,
                alignment: 'right',
                width: 'auto',
              },
            ],
            margin: [0, 0, 0, 5],
          }
          : null,

        // Separator
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 206.77,
              y2: 0,
              lineWidth: 1,
              dash: { length: 2 },
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // Totals
        {
          columns: [
            { text: '', width: '*' },
            {
              width: 'auto',
              table: {
                widths: [80, 50],
                body: [
                  [
                    { text: 'Subtotal:', fontSize: 9 },
                    {
                      // text: this.formatCurrencyWhole(data.subtotal),
                      text: this.formatCurrencyWhole(subtotalExclFree),
                      fontSize: 9,
                      alignment: 'right',
                    },
                  ],
                  // Show item discount if present
                  data.itemDiscount && data.itemDiscount > 0
                    ? [
                      { text: 'Item Discount:', fontSize: 9 },
                      {
                        text: `-${this.formatCurrencyWhole(data.itemDiscount)}`,
                        fontSize: 9,
                        alignment: 'right',
                      },
                    ]
                    : null,
                  // Show overall discount if present
                  data.overallDiscount && data.overallDiscount > 0
                    ? [
                      { text: 'Overall Discount:', fontSize: 9 },
                      {
                        text: `-${this.formatCurrencyWhole(data.overallDiscount)}`,
                        fontSize: 9,
                        alignment: 'right',
                      },
                    ]
                    : null,
                  // Fallback to single discount if separate discounts not available
                  !data.itemDiscount &&
                    !data.overallDiscount &&
                    data.discount &&
                    data.discount > 0
                    ? [
                      { text: 'Discount:', fontSize: 9 },
                      {
                        text: `-${this.formatCurrencyWhole(data.discount)}`,
                        fontSize: 9,
                        alignment: 'right',
                      },
                    ]
                    : null,
                  (Number(data.loyaltyAmount) || 0) > 0
                    ? [
                      {
                        text: `Loyalty Discount (${Number(data.loyaltyPoints) || 0} pts):`,
                        fontSize: 9,
                      },
                      {
                        text: `-${this.formatCurrencyWhole(Number(data.loyaltyAmount) || 0)}`,
                        fontSize: 9,
                        alignment: 'right',
                      },
                    ]
                    : null,
                  data.taxAmount && data.taxAmount > 0
                    ? [
                      { text: 'Tax:', fontSize: 9 },
                      {
                        text: this.formatCurrencyWhole(data.taxAmount),
                        fontSize: 9,
                        alignment: 'right',
                      },
                    ]
                    : null,
                  [
                    { text: 'Total:', fontSize: 11, bold: true },
                    {
                      text: this.formatCurrencyWhole(
                        (data.totalAmount || data.grandTotal || 0) -
                        (data.overallDiscount || 0) -
                        (Number(data.loyaltyAmount) || 0),
                      ),
                      fontSize: 11,
                      alignment: 'right',
                      bold: true,
                    },
                  ],
                ].filter(Boolean) as any,
              },
              layout: 'noBorders',
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // Payment Info
        data.paidamount
          ? {
            columns: [
              { text: '', width: '*' },
              {
                width: 'auto',
                table: {
                  widths: [60, 50],
                  body: [
                    [
                      { text: 'Paid:', fontSize: 9 },
                      {
                        text: this.formatCurrencyWhole(data.paidamount),
                        fontSize: 9,
                        alignment: 'right',
                      },
                    ],
                    data.balanceamount && data.balanceamount > 0
                      ? [
                        { text: 'Balance:', fontSize: 9, bold: true },
                        {
                          text: this.formatCurrencyWhole(data.balanceamount),
                          fontSize: 9,
                          alignment: 'right',
                          bold: true,
                        },
                      ]
                      : null,
                  ].filter(Boolean) as any,
                },
                layout: 'noBorders',
              },
            ],
            margin: [0, 0, 0, 10],
          }
          : null,

        // Separator
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 206.77,
              y2: 0,
              lineWidth: 1,
              dash: { length: 2 },
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // Footer
        {
          text: data.notes || 'Thank you for your business!',
          fontSize: 9,
          alignment: 'center',
          italics: true,
          margin: [0, 0, 0, 10],
        },
      ].filter(
        (item): item is Exclude<typeof item, null> => item !== null,
      ) as any,

      styles: {
        header: {
          fontSize: 14,
          bold: true,
        },
        businessInfo: {
          fontSize: 8,
        },
        tableHeader: {
          fontSize: 9,
          bold: true,
        },
      },
    };
  }
}
